import { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { Property } from '../../types/user';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

interface PropertyFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: { name: string; location: string }) => Promise<void>;
  editingProperty: Property | null;
  initialData: {
    name: string;
    location: string;
  };
}

export const PropertyFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  editingProperty,
  initialData
}: PropertyFormModalProps) => {
  const [formData, setFormData] = useState(initialData);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(formData);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed inset-0 z-10 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen px-4">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="relative bg-white rounded-lg p-6 max-w-md w-full mx-auto">
          <Dialog.Title className="text-lg font-semibold mb-4">
            {editingProperty ? 'Editar Propiedad' : 'Nueva Propiedad'}
          </Dialog.Title>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Nombre"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="Ej: Casa Playa"
              required
            />

            <Input
              label="Ubicación"
              value={formData.location}
              onChange={(e) => setFormData({ ...formData, location: e.target.value })}
              placeholder="Ej: Málaga"
              required
            />

            {!editingProperty && (
              <p className="text-sm text-gray-500 mt-4">
                Los datos estadísticos y mensuales se podrán gestionar una vez creada la propiedad.
              </p>
            )}

            <div className="flex justify-end space-x-3 pt-4">
              <Button
                variant="secondary"
                onClick={onClose}
                type="button"
              >
                Cancelar
              </Button>
              <Button type="submit">
                {editingProperty ? 'Actualizar' : 'Crear'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
};